import { useEffect } from 'react';
import { logout } from '../firebase.config';

function Logout() {
  useEffect(() => {
    logout();
  }, []);

  return <p></p>;
}

export default Logout;
